export const ABOUT_ME_PAGES = {
    BASE_ROUTE: "/about-me",
    PERSONAL_INFO: "1",
    LOCATION_CAPTURE: "2",
    PARSE_RESUME: "parse-resume",
}

export const ABOUT_ME_QUERY_KEYS = {
    GET_ENRICHED_PROFILE: "get-enriched"
}

export const ABOUT_ME_PERSONAL_DETAILS_INITIAL_VALUES = {
    name: "",
    email: "",
    dob: null,
    gender: "",
    isPrefilled: false,
};

    
export const ABOUT_ME_LOCATION_DETAILS_INITIAL_VALUES = { city: null, area: null, isPrefilled: false, };

export const ABOUT_ME_INTIAL_VALUE = {
    personalDetails: ABOUT_ME_PERSONAL_DETAILS_INITIAL_VALUES,
    locationDetails: ABOUT_ME_LOCATION_DETAILS_INITIAL_VALUES,
    whatsappPreference: true,
}

export const GENDER_MAP = {
    f: "FEMALE",
    m: "MALE"
}